export const VISIBLE_DOTS = 5;
export const VISIBLE_SIDE_DOTS = (VISIBLE_DOTS - 1) / 2; // Subtract active dot then split in half
export const VISIBLE_SIDE_DOTS_WITH_ACTIVE = VISIBLE_SIDE_DOTS + 1; // Add active dot back in
export const FAR_DOT = 2; // Far position is 2 positions away from the active dot
export const FARTHER_DOT = FAR_DOT + 1; // Farther position is 1 position away from the far position
export const MOVE_DURATION = 200; // Move duration is 200ms
